import React from 'react';

const NotificationBanner = ({ message, type, onClose }) => {
  const bgColor = type === 'success' ? 'bg-green-100' : 'bg-red-100';
  const textColor = type === 'success' ? 'text-green-800' : 'text-red-800';
  const borderColor = type === 'success' ? 'border-green-200' : 'border-red-200';

  return (
    <div className={`fixed top-4 right-4 z-50 p-4 rounded-lg border ${bgColor} ${borderColor} shadow-sm max-w-md`}>
      <div className="flex justify-between items-center">
        <p className={`text-sm ${textColor} font-medium`}>{message}</p>
        <button
          onClick={onClose}
          className={`ml-4 ${textColor} hover:opacity-70`}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default NotificationBanner; 